import messages from "messages";
import { HTMLProps, useState } from "react";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
// styles
import styles from "./styles.module.scss";
// components
import Toast from "components/toast";
// utils
import getClasses from "utils/getClasses";

type Props = {
  fileUrl: string;
} & HTMLProps<HTMLDivElement>;
const BillingViewerPdf = ({
  fileUrl,
  className,
  children,
  ...props
}: Props) => {
  const [
    file,
    // setFile
  ] = useState({
    url: fileUrl,
    withCredentials: true,
  });

  const [numPages, setNumPages] = useState(0);

  return (
    <div
      className={getClasses(styles["billing-viewer-pdf"], className)}
      {...props}
    >
      {children}
      {fileUrl && (
        <>
          <Document
            className={styles["billing-viewer-pdf__document"]}
            file={file}
            loading={
              <Toast className={styles["billing-viewer-pdf__toast"]}>
                {messages.loading}
              </Toast>
            }
            // should be the same for error and no data
            error={
              <Toast className={styles["billing-viewer-pdf__toast"]}>
                {messages.oops}
              </Toast>
            }
            noData={
              <Toast className={styles["billing-viewer-pdf__toast"]}>
                {messages.oops}
              </Toast>
            }
            onLoadSuccess={({ numPages }) => setNumPages(numPages)}
          >
            {Array(numPages)
              .fill(0)
              .map((_, index) => (
                <Page
                  key={index}
                  className={styles["billing-viewer-pdf__page"]}
                  pageNumber={index + 1}
                />
              ))}
          </Document>
        </>
      )}
    </div>
  );
};

export default BillingViewerPdf;
